import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import store from "@/store/instance";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import { DecorationType, IQuestionComonentType, QuestionType } from "../config/questionnaire";
import { getQuestionnaireDetail, saveQuestionnaire, saveQuestionnaireDraft, getQuestionnaireDraftByCommtyId, checkItemExist } from "@modules/newCommunity/pages/operationTools/api/questionnaire";
import { walkArray } from "@/utils/commonUtil";
export var QuestionnaireSettingAction;
(function (QuestionnaireSettingAction) {
  QuestionnaireSettingAction[QuestionnaireSettingAction["basic_setting"] = 0] = "basic_setting";
  QuestionnaireSettingAction[QuestionnaireSettingAction["empty"] = -1] = "empty";
  QuestionnaireSettingAction[QuestionnaireSettingAction["question"] = 1] = "question";
  QuestionnaireSettingAction[QuestionnaireSettingAction["submitBtn"] = 2] = "submitBtn";
  QuestionnaireSettingAction[QuestionnaireSettingAction["submitPageBtn"] = 3] = "submitPageBtn";
})(QuestionnaireSettingAction || (QuestionnaireSettingAction = {}));
const defaultForm = {
  questionData: {
    uniqueId: "",
    title: "标题",
    introduce: "",
    remark: "",
    hideIntro: 0,
    exitPopup: "0",
    coverUrl: "",
    tips: "确定要放弃填写吗？",
    submitTitle: "提交",
    submitText: "本活动最终解释权归爱问所有",
    status: "",
    userAuth: 0,
    popupText: "确定要放弃填写吗？ ",
    leaveBtnText: "确认",
    cancelBtnText: "取消"
  },
  basicData: {
    title: "标题",
    remark: "",
    coverSet: true,
    cover: "",
    coverIntroduce: "",
    coverBtnText: "开始答题",
    shareSet: true,
    shareCover: "https://picture.wenwo.com/fimg/2f3582051f736b9520448c8ef6693a12.jpg",
    shareTitle: "",
    shareIntroduce: "",
    submitLimit: true,
    submitLimitCount: 1,
    loginSet: true,
    joinDoctorLimit: "COMMUNITYDOCTOR",
    joinDoctorType: [],
    exitPopup: "1",
    popupText: "确定要放弃填写吗？",
    pageSet: "COMBINE"
  },
  submitData: {
    countdown: 3,
    jumpLinkType: 1,
    jumpType: 0,
    linkUrl: "index",
    picUrl: "",
    questionnaireId: "",
    qualifiedScore: 0,
    tips: "正在转入社区首页，请稍后",
    title: "您的答卷已经提交，感谢您的参与！"
  },
  activeIndex: 0,
  dataList: []
};
const jumpUrl = {
  index: {
    label: "社区首页",
    url: "index",
    value: "index"
  },
  doctors: {
    label: "名医诊室",
    url: "doctors",
    value: "doctors"
  },
  institution: {
    label: "机构列表",
    url: "institution",
    value: "institution"
  },
  tieba: {
    label: "健康圈",
    url: "tieba",
    value: "tieba"
  },
  topics: {
    label: "话题列表",
    url: "topics",
    value: "topics"
  },
  questions: {
    label: "问答列表",
    url: "tieba#qA",
    value: "questions"
  },
  article: {
    label: "文章资讯",
    url: "article",
    value: "article"
  },
  introduce: {
    label: "社区简介",
    url: "mine/about",
    value: "introduce"
  }
};
let QuestionnaireEdit = class QuestionnaireEdit extends VuexModule {
  constructor() {
    super(...arguments);
    this.questionnaireType = "QUESTIONNAIRE";
    this.questionnaireSource = "PATIENT";
    this.totalScore = "0";
    this.jumpUrl = jumpUrl;
    this.action = QuestionnaireSettingAction.basic_setting;
    this.questionData = defaultForm.questionData; // $ 问卷调查数据
    this.submitData = defaultForm.submitData;
    this.basicData = defaultForm.basicData;
    this.activeIndex = defaultForm.activeIndex; // $ 当前点击索引
    this.dataList = defaultForm.dataList;
    this.dattpaList = defaultForm.dataList;
    this.activeData = {
      componentName: QuestionType.empty,
      componentType: IQuestionComonentType.Question,
      data: {}
    };
    this.stagDataList = [];
  }
  // $ 基本信息设置
  SET_QUESTIONTYPE_DATA(tp) {
    this.questionnaireType = tp;
  }
  SET_QUESTIONNAIRESOURCE_DATA(tp) {
    this.questionnaireSource = tp;
  }
  SET_TOTALSCORE_DATA(tp) {
    this.totalScore = tp;
  }
  // @Mutation
  // SET_BASICS_DATA() {
  //   this.action = QuestionnaireSettingAction.basic_setting;
  // }
  // $ 提交按钮设置
  SET_SUBMIT_DATA() {
    this.action = QuestionnaireSettingAction.submitBtn;
  }
  // $ 设置当前点击索引
  SET_INDEX_COMPONENTS(index) {
    this.action = QuestionnaireSettingAction.question;
    this.activeIndex = index;
    this.activeData = this.dataList[index];
  }
  // $ 拖动组件数据
  SET_DATALIST_COMPONENTS(payload) {
    this.dataList = payload;
  }
  // $ 添加组件
  SET_ADD_COMPONENTS(payload) {
    const item = payload.item;
    const data = {
      componentName: item.componentName,
      componentType: item.type,
      data: {
        ...item.data,
        title: item.title,
        catalogIds: [],
        whetherJoinQuestionBank: false
      }
    };
    this.dataList.splice(this.activeIndex + 1, 0, data);
  }
  UPDATE_COMPONENTS(payload) {
    this.dataList[payload.index].data = payload.item;
  }
  // $ 删除组件
  SET_DELETE_COMPONENTS(payload) {
    console.warn("payload", payload);
    this.dataList.splice(payload, 1);
    console.warn("dataList", this.dataList);
    if (this.dataList.length == 0) {
      this.action = QuestionnaireSettingAction.basic_setting;
    }
  }
  // $ 问卷调查数据
  SET_BASIC_DATA(payload) {
    this.basicData = payload;
  }
  // $ 获取问卷调查数据
  SET_DATA_LIST(payload) {
    this.dataList = payload;
  }
  // $ 获取提交页设置数据
  SET_SUBMIT_LIST(payload) {
    this.submitData = payload;
  }
  SET_BASIC_LIST(payload) {
    this.basicData = payload;
  }
  SET_BASIC_DATA_SHARECOVER(payload) {
    this.basicData.shareCover = payload;
  }
  // $ 重置数据
  SET_RESET_STORE() {
    this.questionnaireType = "QUESTIONNAIRE";
    this.questionData = JSON.parse(JSON.stringify(defaultForm.questionData));
    this.submitData = JSON.parse(JSON.stringify(defaultForm.submitData));
    if (this.questionnaireSource == "DOCTOR") {
      this.submitData.jumpLinkType = 2;
      this.submitData.linkUrl = "";
    }
    this.basicData = JSON.parse(JSON.stringify(defaultForm.basicData));
    this.activeIndex = JSON.parse(JSON.stringify(defaultForm.activeIndex));
    this.dataList = JSON.parse(JSON.stringify(defaultForm.dataList));
  }
  // $
  SET_NUMBER_INDEX(payload) {
    this.dataList[payload.index].data.number = payload.number;
  }
  // * 设置从题库中选择的数据
  SET_STAG_DATA_LIST(payload) {
    this.stagDataList = payload;
  }
  // * 重置从题库中选择的数据
  RESET_STAG_DATA_LIST() {
    this.stagDataList = [];
  }
  // // $ 隐藏问卷介绍
  // @Mutation
  // SET_HIDE_INTRO(payload: any) {
  //   this.questionData.hideIntro = payload;
  // }
  // @Action({commit: 'updatePosts'})
  // async function fetchPosts() {
  //     return await get('https://jsonplaceholder.typicode.com/posts')
  // }
  // $ 获取问卷详情
  GET_QUESTIONNAIRE_DETAIL(params) {
    getQuestionnaireDetail(params).then(data => {
      const result = transformToUIData(data);
      console.warn("transformToUIData", result);
      this.SET_QUESTIONTYPE_DATA(data.questionnaireType);
      this.SET_BASIC_DATA(result.basicData);
      this.SET_DATA_LIST(result.datalist);
      this.SET_SUBMIT_LIST(result.submitData);
    });
  }
  // $ 保存暂存数据
  async SAVE_QUESTIONNAIRE_DRAFT() {
    const basicData = this.basicData;
    const questionnaireType = this.questionnaireType;
    const questionnaireSource = this.questionnaireSource;
    const params = transformToServerData(store.state, questionnaireType, questionnaireSource, basicData, this.dataList, this.submitData);
    return saveQuestionnaireDraft(params).then(data => {
      return data;
    }).catch(error => {
      return error;
    });
  }
  // $ 保存问卷
  async SAVE_QUESTIONNAIRE(id) {
    const basicData = this.basicData;
    const questionnaireType = this.questionnaireType;
    const questionnaireSource = this.questionnaireSource;
    const params = transformToServerData(store.state, questionnaireType, questionnaireSource, basicData, this.dataList, this.submitData);
    params.id = id;
    return await saveQuestionnaire(params).then(data => {
      return data;
    }).catch(error => {
      return error;
    });
  }
  // $ 获取暂存数据
  async GET_QUESTIONNAIREDraftByCommtyId() {
    // const questionData = this.questionData;
    return getQuestionnaireDraftByCommtyId({
      communityId: store.state.comtyId,
      questionnaireType: this.questionnaireType,
      questionnaireSource: this.questionnaireSource
    }).then(res => {
      console.warn("getQuestionnaireDraftByCommtyId", res);
      const data = res.data;
      if (Object.keys(data).length > 1) {
        const result = transformToUIData(data);
        this.SET_BASIC_DATA(result.basicData);
        this.SET_DATA_LIST(result.datalist);
        this.SET_SUBMIT_LIST(result.submitData);
      }
      return data;
    }).catch(error => {
      return error;
    });
  }
  async CHECK_DATA() {
    const basicData = this.basicData;
    const questionnaireType = this.questionnaireType;
    const questionnaireSource = this.questionnaireSource;
    const params = transformToServerData(store.state, questionnaireType, questionnaireSource, basicData, this.dataList, this.submitData);
    return await checkItemExist(params).then(data => {
      return data;
    }).catch(error => {
      return error;
    });
  }
};
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_QUESTIONTYPE_DATA", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_QUESTIONNAIRESOURCE_DATA", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_TOTALSCORE_DATA", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_SUBMIT_DATA", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_INDEX_COMPONENTS", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_DATALIST_COMPONENTS", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_ADD_COMPONENTS", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "UPDATE_COMPONENTS", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_DELETE_COMPONENTS", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_BASIC_DATA", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_DATA_LIST", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_SUBMIT_LIST", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_BASIC_LIST", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_BASIC_DATA_SHARECOVER", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_RESET_STORE", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_NUMBER_INDEX", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_STAG_DATA_LIST", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "RESET_STAG_DATA_LIST", null);
__decorate([Action], QuestionnaireEdit.prototype, "GET_QUESTIONNAIRE_DETAIL", null);
__decorate([Action], QuestionnaireEdit.prototype, "SAVE_QUESTIONNAIRE_DRAFT", null);
__decorate([Action], QuestionnaireEdit.prototype, "SAVE_QUESTIONNAIRE", null);
__decorate([Action], QuestionnaireEdit.prototype, "GET_QUESTIONNAIREDraftByCommtyId", null);
__decorate([Action], QuestionnaireEdit.prototype, "CHECK_DATA", null);
QuestionnaireEdit = __decorate([Module({
  name: "questionnaireEditNew",
  dynamic: true,
  namespaced: true,
  store
})], QuestionnaireEdit);
export default QuestionnaireEdit;
// !初始化问卷答题数据
export function transformToUIData(data) {
  const basicData = {
    uniqueId: data.id || undefined,
    title: data.title,
    remark: data.remark,
    coverSet: data.coverSet || false,
    cover: data.cover || "",
    coverIntroduce: data.coverIntroduce || "",
    coverBtnText: data.coverBtnText || "",
    shareSet: data.shareSet || false,
    shareCover: data.shareCover || "https://picture.wenwo.com/fimg/2f3582051f736b9520448c8ef6693a12.jpg",
    shareTitle: data.shareTitle || "",
    shareIntroduce: data.shareIntroduce || "",
    submitLimit: data.submitLimit || false,
    submitLimitCount: data.submitLimitCount || 1,
    loginSet: data.loginSet || false,
    joinDoctorLimit: data.joinDoctorLimit || "COMMUNITYDOCTOR",
    joinDoctorType: data.joinDoctorType || [],
    exitPopup: data.exitPopup + "",
    popupText: data.popupText,
    pageSet: data.pageSet
  };
  const serviceSubmitData = data.submitItemList[0];
  const submitData = {
    countdown: serviceSubmitData.countdown,
    jumpLinkType: serviceSubmitData.jumpLinkType || 1,
    jumpType: serviceSubmitData.jumpType || 0,
    linkUrl: serviceSubmitData.linkUrl,
    picUrl: serviceSubmitData.picUrl,
    questionnaireId: serviceSubmitData.questionnaireId,
    tips: serviceSubmitData.tips,
    title: serviceSubmitData.title,
    qualifiedScore: data.qualifiedScore || 0
  };
  const datalist = [];
  walkArray(data.itemList, item => {
    const question = {
      componentName: item.type,
      data: {
        id: item.id,
        required: item.required,
        number: item.number,
        type: item.componentName,
        style: item.componentType,
        whetherJoinQuestionBank: item.joinBank || false,
        fromQuestionBank: !!item.fromQuestionBank,
        catalogIds: item.catalogIds || []
      }
    };
    if (item.type == QuestionType.singleChoice || item.type == QuestionType.multipleChoice || item.type == QuestionType.cascade) {
      const data = question.data;
      data.optionsList = item.optionsList;
      data.title = item.question;
      data.optionContentType = item.optionContentType;
      data.itemScore = item.itemScore || 0;
      //       optionContentType: string; // 是否必填: number;
      // itemScore?: number;
    }
    if (item.type == DecorationType.picture) {
      const data = question.data;
      try {
        const jsonConfig = JSON.parse(item.jsonConfig);
        data.url = jsonConfig.url;
      } catch (error) {
        console.log(error, item.jsonConfig);
        data.url = "";
      }
    }
    if (item.type == DecorationType.text) {
      const data = question.data;
      try {
        const jsonConfig = JSON.parse(item.jsonConfig);
        data.text = jsonConfig.text;
      } catch (error) {
        console.log(error, item.jsonConfig);
        data.text = "";
      }
    }
    if (item.type == QuestionType.uploadAddon) {
      const data = question.data;
      data.title = item.question;
      data.uploadLimitCount = item.uploadLimitCount;
    }
    if (item.type == QuestionType.phoneNumber) {
      const data = question.data;
      data.title = item.question;
      try {
        const jsonConfig = JSON.parse(item.jsonConfig);
        data.phoneNumber = jsonConfig.default; //填空题的默认文本
      } catch (error) {
        console.log(error, item.jsonConfig);
        data.phoneNumber = "";
      }
    }
    if (item.type == QuestionType.fillIn) {
      const data = question.data;
      data.title = item.question;
      data.itemScore = item.itemScore;
      data.rightText = item.rightText;
      data.scoreRule = item.scoreRule;
      try {
        const jsonConfig = JSON.parse(item.jsonConfig);
        data.content = jsonConfig.default; //填空题的默认文本
      } catch (error) {
        console.log(error, item.jsonConfig);
        data.content = "";
      }
    }
    // (question.data as IQuestion).whetherJoinQuestionBank = false;
    datalist.push(question);
  });
  return {
    basicData,
    datalist,
    submitData
  };
}
function transformToServerData(rootState, questionnaireType, questionnaireSource, basicData, dataList, submitData) {
  const itemList = transformDataListToServerData(dataList);
  const params = {
    questionnaireType,
    questionnaireSource,
    ...basicData,
    submitItemList: [submitData],
    qualifiedScore: submitData.qualifiedScore || 0,
    itemList: itemList
  };
  if (questionnaireSource == "PATIENT") {
    delete params.joinDoctorLimit;
    delete params.joinDoctorType;
  }
  console.log("transformToServerData", params);
  return params;
}
export function transformDataListToServerData(datalist) {
  const data = datalist.map(item => {
    const formData = item.data;
    console.warn("formData", formData);
    const question = {
      required: formData.required,
      type: item.componentName,
      style: item.componentType,
      number: formData.number,
      catalogIds: formData.catalogIds || [],
      joinBank: !!formData.whetherJoinQuestionBank,
      fromQuestionBank: !!formData.fromQuestionBank
    };
    if (formData.id) question.id = formData.id;
    if (item.componentName == QuestionType.singleChoice || item.componentName == QuestionType.multipleChoice || item.componentName == QuestionType.cascade) {
      question.optionsList = formData.optionsList;
      question.question = formData.title;
      question.itemScore = formData.itemScore;
      question.optionContentType = formData.optionContentType;
    }
    if (item.componentName == QuestionType.fillIn) {
      const jsonConfig = {
        default: formData.content
      };
      question.jsonConfig = JSON.stringify(jsonConfig);
      question.question = formData.title;
      question.itemScore = formData.itemScore;
      question.rightText = formData.rightText;
      question.scoreRule = formData.scoreRule;
    }
    if (item.componentName == DecorationType.picture) {
      const jsonConfig = {
        url: formData.url
      };
      question.jsonConfig = JSON.stringify(jsonConfig);
    }
    if (item.componentName == DecorationType.text) {
      const jsonConfig = {
        text: formData.text
      };
      question.jsonConfig = JSON.stringify(jsonConfig);
    }
    if (item.componentName == QuestionType.phoneNumber) {
      const jsonConfig = {
        default: formData.phoneNumber
      };
      question.jsonConfig = JSON.stringify(jsonConfig);
      question.question = formData.title;
    }
    if (item.componentName == QuestionType.uploadAddon) {
      const data = formData;
      question.question = data.title;
      question.uploadLimitCount = data.uploadLimitCount;
    }
    return question;
  });
  return data;
}
export const QuestionnaireEditModule = getModule(QuestionnaireEdit);